export default{
    SET_OUTPUT_CHAT_MESSAGES_INDEX: (state, index) => {
        state.outputChatMessagesIndex = index
        localStorage.setItem('outputChatMessagesIndex', index)
        // console.log('state.outputChatMessagesIndex', state.outputChatMessagesIndex)       
    },
}